import { Link } from 'react-router-dom';

const MARK = {
  sm: 'h-9 w-9',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-14 w-14',
};

const WORDMARK = {
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-2xl',
  xl: 'text-3xl',
};

/**
 * Aura Book brand: icon mark + app name, side-by-side by default.
 */
const BrandLogo = ({
  to = '/',
  size = 'md',
  showWordmark = true,
  showTagline = false,
  stacked = false,
  className = '',
  onClick,
}) => {
  const mark = MARK[size] || MARK.md;
  const titleSize = WORDMARK[size] || WORDMARK.md;

  const content = (
    <span
      className={`inline-flex ${
        stacked ? 'flex-col items-center gap-3 text-center' : 'items-center gap-3'
      } ${className}`}
    >
      <span
        className={`${mark} shrink-0 overflow-hidden rounded-xl border border-gold-500/25 bg-black shadow-gold`}
      >
        <img
          src="/brand/aura-book-mark.png"
          alt=""
          aria-hidden
          className="h-full w-full object-cover"
        />
      </span>

      {showWordmark && (
        <span
          className={`min-w-0 flex flex-col ${
            stacked ? 'items-center' : 'items-start justify-center'
          }`}
        >
          <span className={`font-display font-semibold tracking-tight ${titleSize} leading-none`}>
            <span className="text-aura-300">Aura</span>{' '}
            <span className="bg-gradient-to-r from-glow-400 to-glow-500 bg-clip-text text-transparent">
              Book
            </span>
          </span>
          {showTagline && (
            <span className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.28em] text-gold-500/85">
              Book · Beauty · Relax
            </span>
          )}
        </span>
      )}

      <span className="sr-only">Aura Book</span>
    </span>
  );

  if (!to) return content;

  return (
    <Link
      to={to}
      onClick={onClick}
      className="inline-flex shrink-0 items-center outline-none transition hover:opacity-95 focus-visible:ring-2 focus-visible:ring-glow-500/50 focus-visible:ring-offset-2 focus-visible:ring-offset-[#07040f]"
      aria-label="Aura Book home"
    >
      {content}
    </Link>
  );
};

export default BrandLogo;
